import { createContext, useContext } from 'react';
import { IQuestionnaire } from '../modules/unsw-fhir/Questionnaire';
import { IQuestionnaireResponse } from '../modules/unsw-fhir/QuestionnaireResponse';

export interface QuestionnaireResponseContext {
  questionnaire?: IQuestionnaire;
  questionnaireResponse?: IQuestionnaireResponse;
  setQuestionnaireResponse: (
    questionnaireRespose: IQuestionnaireResponse | undefined,
  ) => void;
  questionnaireResponseLoading?: boolean;
  questionnaireLoading?: boolean;
  error?: string;
}

export const defaultState: QuestionnaireResponseContext = {
  setQuestionnaireResponse: () => {},
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionnaireResponseContext =
  createContext<QuestionnaireResponseContext>(defaultState);

export const useQuestionnaireReponse = () => {
  const questionnaireReponse = useContext(QuestionnaireResponseContext);

  return questionnaireReponse;
};
